<template>
  <div
    id="content-image"
    v-if="!loading">
    <v-divider></v-divider>

    <!-- Edit Form -->
    <form
      name="imageContentItemForm"
      class="mt-5"
      v-if="tab === 'edit'"
      @submit.prevent="updateContentItem('imageItemUpdate')">
      <ImageInput
        v-model="contentItem.fileContents"
        @input="contentItem.content = contentItem.fileContents;"
      />

      <div class="page-buttons d-flex my-5">
        <v-btn
          type="submit"
          color="primary"
          class="order-3">
          Save
        </v-btn>

        <v-btn
          type="button"
          color="primary"
          class="mr-5 order-1"
          :disabled="!contentItem.fileContents"
          @click="removeContentItem('imageItemUpdate')">
          Remove
        </v-btn>

        <v-btn
          @click="goToContentList"
          type="button"
          color="primary"
          class="mr-auto order-0"
          outlined>
          Cancel
        </v-btn>
      </div>
    </form>
    <!-- / Edit Form -->

    <!-- Revisions -->
    <Revisions
      v-if="tab === 'revisions'"
      type="image"
    />
    <!-- / Revisions -->
  </div>
</template>

<script>
import ContentItemMixin from '../mixin.content-item';
import ImageInput from './ImageInput.vue';
import Revisions from './Revisions.vue';

export default {
  name: 'ContentImage',
  props: ['tab'],
  mixins: [
    ContentItemMixin,
  ],
  components: {
    ImageInput,
    Revisions,
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.loading = true;
    this.$store.dispatch('getContentItem', this.$route.params.contentId)
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style lang="scss">
#content-image {
  form[name="imageContentItemForm"] {
    display: inline-block;
    max-width: 900px;

    .page-buttons {
      min-width: 500px;
    }
  }

  form[name="revisionsForm"] {
    max-width: 500px;
  }
}
</style>
